export enum ReactionType {
  ThumbsUp = 'Reactions::ThumbsUp',
}
